/* Picks Shop · celular: el dedo hace lo mismo que el mouse en las sonrisas del hero y del pie. Traduce touchmove a un pointermove de mouse. */
(function () {
  'use strict';
  if (window.__psTouch) return;
  window.__psTouch = true;
  var d = document, w = window;
  if (!w.matchMedia('(pointer: coarse)').matches || w.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof w.PointerEvent !== 'function') return;
  function send(e) {
    var t = e.touches && e.touches[0];
    if (!t) return;
    d.dispatchEvent(new PointerEvent('pointermove', { clientX: t.clientX, clientY: t.clientY, pointerType: 'mouse', bubbles: true }));
  }
  function release() {
    d.dispatchEvent(new PointerEvent('pointermove', { clientX: -9999, clientY: -9999, pointerType: 'mouse', bubbles: true }));
    d.dispatchEvent(new MouseEvent('mouseleave'));
    d.documentElement.dispatchEvent(new MouseEvent('mouseleave'));
  }
  d.addEventListener('touchstart', send, { passive: true });
  d.addEventListener('touchmove', send, { passive: true });
  d.addEventListener('touchend', function () { setTimeout(release, 350); }, { passive: true });
  d.addEventListener('touchcancel', function () { setTimeout(release, 350); }, { passive: true });
})();
